import { render, staticRenderFns } from "./CountryAddress.vue?vue&type=template&id=8bceb588"
import script from "./CountryAddress.vue?vue&type=script&lang=js"
export * from "./CountryAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports